import { useEffect, useState } from "react";
import axios from "axios";
import { NAV_LINKS } from "./data";

let cache = null;
let pending = null;

const loadCases = () => {
  pending ??= axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cases`)
    .then(({ data }) => (cache = data))
    .catch(() => (cache = []));
  return pending;
};

export const useCases = () => {
  const [cases, setCases] = useState(cache || []);
  useEffect(() => { loadCases().then(setCases); }, []);
  return cases;
};

export const useNavLinks = () => {
  const cases = useCases();
  if (!cases.length) return NAV_LINKS;
  const i = NAV_LINKS.findIndex((l) => l.id === "protocollo") + 1;
  return [...NAV_LINKS.slice(0, i), { id: "risultati", label: "Risultati" }, ...NAV_LINKS.slice(i)];
};
